import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyDuplicateConfirmationDialogComponent } from './company-duplicate-confirmation-dialog.component';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { CtButtonModule, CtFrameworkModule } from '@ctsolution/ct-framework';

@NgModule({
  declarations: [
    CompanyDuplicateConfirmationDialogComponent
  ],
  imports: [
    CommonModule,
    MatLegacyDialogModule,
    MatIconModule,
    TranslateModule,
    CtFrameworkModule,
    CtButtonModule
  ],
  exports: [
    CompanyDuplicateConfirmationDialogComponent
  ]
})
export class CompanyDuplicateConfirmationDialogModule { }
